import * as React from "react";

import {isOiaItem}      from "@Common/logic/item/is-oia-item";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {fragments}      from "@Common/react/fragments";
import {Load2}          from "@Common/react/load2";
import {Static2}        from "@Common/react/static-2";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";
import {chain}          from "@Common/utils/fs";

import {TwoOptionModal} from "../../../../../common/two-option-modal/two-option-modal";
import {Layout}         from "../../../../../layout/layout";

export const OIA = ({item, next: rootNext}) => cs(

    (_, next) => !item || !isOiaItem(item) || item?.metaData?.pdfValidation ? (
        rootNext(item && isOiaItem(item))
    ) : (
        next()
    ),

    consumeContext("apis"),
    ["isLastProofAvailable", ({apis}, next) => Load2({
        fetch: async () => await apis.next.isLastProofAvailable(item.itemId),
        next,
    })],
    ({isLastProofAvailable}, next) => isLastProofAvailable.loading ? (
        <Layout className="customize-layout-95r">
            <div className="product-options-step-6rz">
                <div className="center" xd-qa-type="label" xd-qa-name="Loading">
                    Checking proof availability...
                </div>
            </div>
        </Layout>
    ) : (
        next()
    ),
    ({isLastProofAvailable}, next) => item.metaData?.oiaProofs?.length && isLastProofAvailable.value?.[0] ? (
        rootNext({
            proofs: item.metaData.oiaProofs.map((proof) => (
                proof?.url?.length ? (
                    proof.url
                ) : (
                    proof
                )
            )),
        })
    ) : (
        next()
    ),

    consumeContext("routerHistory"),
    ["loader", ({apis}, next) => Load2({
        fetch: () => apis.next.item.getItemProofs(item.itemId),
        next,
    })],
    ({loader, routerHistory}) => fragments(
        rootNext({
            loading: loader.loading,
            proofs: (
                !loader.value?.oiaProofs?.length ? (
                    null
                ) : (
                    loader.value.oiaProofs
                )
            ),
        }),

        cs(
            ["retryCount", (_, next) => Static2({
                getInitValue: () => 0,
                next,
            })],
            ({retryCount}) => chain(
                loader.value?.errors,
                (errors) => errors && (
                    errors.code === "timeout" ? (
                        retryCount.get() < 3 ? (
                            RetryModal({
                                onReload: () => {
                                    retryCount.set(retryCount.get() + 1);
                                    loader.reset();
                                },
                                routerHistory
                            })
                        ) : (
                            FailedModal({
                                message: errors.msg ?? "Timeout error getting OIA proofs",
                                routerHistory
                            })

                        )
                    ) : errors.code === "failed" ? (
                        FailedModal({
                            message: errors.msg,
                            routerHistory
                        })
                    ) : (
                        null
                    )
                ) || null,
            ),
        )
    ),
);


const RetryModal = ({onReload, routerHistory}) => (
    <DeprecatedModalService2 {...{
        initShow: true,
        render: ({}, close) => ({
            content: <TwoOptionModal {...{
                messageLine1: "Your proof is taking a long time to load.",
                messageLine2: "Do you want to go back to home or continue to wait?",
                button1Label: "Go Home",
                button1Action: () => {
                    routerHistory.push("/");
                },
                button2Label: "Keep Waiting",
                button2Action: () => {
                    onReload();
                    close();
                },
            }}/>,
        }),
        onPassiveClose: () => {
            onReload();
        },
    }}/>
);

const FailedModal = ({message, routerHistory}) => cs(
    consumeContext("userLevels"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ({isInternalUser}) => (
        <DeprecatedModalService2 {...{
            initShow: true,
            render: ({}) => ({
                content: <TwoOptionModal {...{
                    messageLine1: "Your proof has failed. Please try again later.",
                    messageLine2: isInternalUser && message,
                    button1Label: "Go Home",
                    button1Action: () => routerHistory.push("/"),
                }}/>,
            }),
            onPassiveClose: () => routerHistory.push("/"),
        }}/>
    ),
);
